module.exports = __webpack_public_path__ + "static/media/sun-riseaura-PH1_1.ff86d162.webp";